function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.22178 8.22183C12.5175 3.92606 19.4824 3.92606 23.7781 8.22183C28.0739 12.5176 28.0739 19.4824 23.7781 23.7782C19.4824 28.0739 12.5175 28.0739 8.22178 23.7782C3.92601 19.4824 3.92601 12.5176 8.22178 8.22183ZM9.63599 9.63604C6.12127 13.1508 6.12127 18.8492 9.63599 22.364C13.1507 25.8787 18.8492 25.8787 22.3639 22.364C25.8786 18.8492 25.8786 13.1508 22.3639 9.63604C18.8492 6.12132 13.1507 6.12132 9.63599 9.63604ZM14.7573 17L11.7573 17C11.205 17 10.7573 16.5523 10.7573 16C10.7573 15.4477 11.205 15 11.7573 15L14.7573 15V12C14.7573 11.4477 15.205 11 15.7573 11C16.3096 11 16.7573 11.4477 16.7573 12V15L19.7573 15C20.3096 15 20.7573 15.4477 20.7573 16C20.7573 16.5523 20.3096 17 19.7573 17L16.7573 17V20C16.7573 20.5523 16.3096 21 15.7573 21C15.205 21 14.7573 20.5523 14.7573 20V17Z",
  fill: "#8798AD",
  className: "svg-fill"
});

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.59c49acb.svg";
export { ForwardRef as ReactComponent };